import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建揽收调度员
export const CREATE_ACCOUNT_TMS_DISPATCHER = gql`
    mutation CreateAccountTmsDispatcher($input: AccountTmsDispatcherInput!) {
        createAccountTmsDispatcher(input: $input)
    }
`;

// 更新揽收调度员
export const UPDATE_ACCOUNT_TMS_DISPATCHER = gql`
    mutation UpdateAccountTmsDispatcher($input: AccountTmsDispatcherInput!) {
        updateAccountTmsDispatcher(input: $input)
    }
`;

export interface AccountTmsDispatcherInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    warehouseId: number;
    role: string;
}

export const createAccountTmsDispatcher = async (input: AccountTmsDispatcherInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_TMS_DISPATCHER,
        variables: {input}
    });
    return data.createAccountTmsDispatcher;
};

export const updateAccountTmsDispatcher = async (input: AccountTmsDispatcherInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_TMS_DISPATCHER,
        variables: {input}
    });
    return data.updateAccountTmsDispatcher;
}; 